import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaChartBar, FaUsers, FaBook, FaChevronRight, FaChevronDown, FaCube, FaEllipsisH, FaCalendarAlt, FaComments, FaCalendarCheck, FaGlobe,FaQrcode } from 'react-icons/fa';

const AdminSidebar = ({
    isHovered,
    setIsHovered,
    isMobileMenuOpen,
    setIsMobileMenuOpen
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [openSubmenu, setOpenSubmenu] = useState('');
    

    const menuItems = [
        { name: 'HOME', path: '/TGSH/admin/Home', icon: <FaChartBar /> },
        { 
            name: 'MEMBERSHIP', 
            path: '/TGSH/admin/MembershipManagement', 
            icon: <FaUsers />, 
            hasSubmenu: true,
            sublinks: [
                { label: 'Registered Users', path: '/registered' },
                { label: 'Non Residence Users', path: '/non-residence' },
                { label: 'Reactivate Course', path: '/reactivate' }
            ]
        },
        { 
            name: 'COURSES', 
            path: '/TGSH/admin/CoursesDetails', 
            icon: <FaBook />, 
            hasSubmenu: true,
            sublinks: [
                { label: 'Courses', path: '/courses' }, 
                { label: 'Add Video & Study Material', path: '/addvideoandstudymaterial' }
            ]
        },
        {
            name: 'MASTER',
            path: '/TGSH/admin/Master',
            icon: <FaCube />,
            hasSubmenu: true,
            sublinks: [
                { label: 'Title Master', path: '/titlemaster' },
                { label: 'Question Master', path: '/questionmaster' },
                { label: 'Conclusion Master', path: '/conclusionmaster' },
                { label: 'Material Type', path: '/materialtype' }
            ]
        },
        {
            name: 'OTHERS',
            path: '/TGSH/admin/Others',
            icon: <FaEllipsisH />,
            hasSubmenu: true,
            sublinks: [
                { label: 'Enquiry Details', path: '/enquirydetails' },
                { label: 'Blog Article', path: '/blogarticle' },
                { label: 'Add Event', path: '/addevent' },
                { label: 'Feedback Vidoes', path: '/feedbackvideos' },
                { label: 'Feedback Statement', path: '/feedbackstatement' }
            ]
        },
        {
            name: 'REPORTS',
            path: '/TGSH/admin/Reports',
            icon: <FaChartBar />,
            hasSubmenu: true,
            sublinks: [
                { label: 'Registration Report', path: '/registrationreport' },
                { label: 'Course Report', path: '/coursereport' },
                { label: 'Transaction Report', path: '/transactionreport' },
                { label: 'UpcomingEvent Report', path: '/upcomingeventpaymentreport' },
                { label: 'ScanEntry Report', path: '/scanentryreport' }
            ]
        },
        
        { name: 'UPCOMING EVENTS', path: '/TGSH/admin/AddUpcomingEvents', icon: <FaCalendarAlt /> },
        { name: 'CHATS', path: '/TGSH/admin/Chat', icon: <FaComments /> },
        { name: 'APPOINTMENTS', path: '/TGSH/admin/AppointmentBooking', icon: <FaCalendarCheck /> },
        {
            name: 'ADD WEBCONTENT',
            path: '/TGSH/admin/WebContentManage',
            icon: <FaGlobe />
           


        },
        {
            name: 'SCAN ENTRY',
            path: '/TGSH/admin/ScanEntry',
            icon: <FaQrcode />
           


        },
    ];

    const toggleSubmenu = (item) => {
        if (item.hasSubmenu) {
            setOpenSubmenu(openSubmenu === item.name ? '' : item.name);
        } else {
            navigate(item.path);
            setOpenSubmenu('');

            if (isMobileMenuOpen) {
                setIsMobileMenuOpen(false);
            }
        }
    };

    return (
        <>
            {isMobileMenuOpen && (
                <div
                    className="fixed inset-0 bg-black/40 z-[499] md:hidden"
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}
        
        <aside
            
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => { setIsHovered(false); setOpenSubmenu(''); }}
            className={`
            fixed
            top-[16px]
            bottom-0
            z-[500]
            bg-[#212121]
            text-white
            transition-all
            duration-300

            ${isMobileMenuOpen ? 'translate-x-0 w-64' : '-translate-x-full w-64'}

            md:translate-x-0
            md:left-0
            ${isHovered ? 'md:w-64' : 'md:w-20'}
            `}
                    >

            <div className="md:hidden flex justify-between items-center px-4 py-3 border-b border-white/10">
                <span className="text-sm font-semibold tracking-wider text-white/80">
                    MENU
                </span>

                <button
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="
                        w-10
                        h-10
                        flex
                        items-center
                        justify-center
                        rounded-full
                        hover:bg-white/10
                        transition
                    "
                >
                    ✕
                </button>
            </div>
            <nav className="mt-4 flex-1 px-3 space-y-1 overflow-y-auto scrollbar-thin">
                {menuItems.map((item,index) => (
                    <div key={index} className="w-full">
                        <button
                            onClick={() => toggleSubmenu(item)}
                            className={`w-full flex items-center justify-between p-3 rounded-lg transition-all duration-200 
                            ${location.pathname.includes(item.path) 
                                ? 'bg-white/10 text-[#64a106]' 
                                : 'text-white hover:bg-white/10'}`}
                        >
                            <div className="flex items-center gap-2 md:gap-4">
                                <span className="text-lg md:text-xl flex-shrink-0 w-5 md:w-6 flex justify-center text-white">{item.icon}</span>
                                {(isHovered || isMobileMenuOpen) && (
                                    <span className="font-bold text-[11px] uppercase tracking-widest whitespace-normal leading-tight text-left">
                                        {item.name}
                                    </span>
                                )}
                            </div>
                            {(isHovered || isMobileMenuOpen) && item.hasSubmenu && (
                                <FaChevronDown className={`text-[10px] transition-transform duration-300 ${openSubmenu === item.name ? 'rotate-180' : ''}`} />
                            )}
                        </button>

                        {/* Accordion Submenu */}
                        {item.hasSubmenu &&
                                openSubmenu === item.name &&
                                (isHovered || isMobileMenuOpen) && (
                                    <div className="relative ml-6 mt-1 flex flex-col space-y-1 animate-fadeIn border-l border-white/10">
                                        {item.sublinks?.map((sub) => (
                                            <button
                                                key={sub.label}
                                                onClick={() => {
                                                    navigate(`${item.path}${sub.path}`);
                                                    setOpenSubmenu('');
                                                    setIsMobileMenuOpen(false);
                                                }}
                                                className="text-left py-2 text-[12px] font-normal text-white/80 hover:text-[#64a106] transition-all bg-transparent border-none cursor-pointer uppercase tracking-widest relative"
                                                style={{
                                                    paddingLeft: '35px',
                                                    whiteSpace: 'normal',
                                                    lineHeight: '1.4'
                                                }}
                                            >
                                                <span className="absolute left-0 top-3 text-white/40">
                                                    -
                                                </span>

                                                <span className="block">
                                                    {sub.label}
                                                </span>
                                            </button>
                                        ))}
                                    </div>
                            )}
                    </div>
                ))}
            </nav>

            <div className="p-4 border-t border-white/10 flex items-center gap-3 text-white/40 cursor-pointer">
                <FaChevronRight className={`text-xs transition-transform duration-300 ${isHovered ? 'rotate-180' : ''}`} />
                {(isHovered || isMobileMenuOpen) && <span className="text-[10px] font-bold uppercase tracking-tighter">Admin Panel v1.0</span>}
            </div>
        </aside>
    </>
    );
};

export default AdminSidebar;